import { api } from "./api-lib/api";
import { request } from "./helper.actions";

export const RESET_REPORT_STATE = "RESET_REPORT_STATE";

export const resetReportState = () => dispatch => {
  dispatch({
    type: RESET_REPORT_STATE
  })
}

export const LIST_REPORTS_SUCCESS = "LIST_REPORTS_SUCCESS";
export const LIST_REPORTS_FAILURE = "LIST_REPORTS_FAILURE";

const listReportsSuccess = resp => ({
  type: LIST_REPORTS_SUCCESS,
  resp
});

const listReportsFailure = error => ({
  type: LIST_REPORTS_FAILURE,
  error
});

export const listReports = () => dispatch => {
  dispatch(request());
  return api
    .get("/financial_institutions/reports")
    .then(resp => {
      dispatch(listReportsSuccess(resp));
      return Promise.resolve(resp);
    })
    .catch(error => {
      dispatch(listReportsFailure(error));
      return Promise.reject(error);
    });
};

export const LIST_ATTRIBUTES_SUCCESS = 'LIST_ATTRIBUTES_SUCCESS'
export const LIST_ATTRIBUTES_FAILURE = 'LIST_ATTRIBUTES_FAILURE'

const listAttirbutesSuccess = resp => ({
  type: LIST_ATTRIBUTES_SUCCESS,
  resp
});

const listAttirbutesFailure = resp => ({
  type: LIST_ATTRIBUTES_FAILURE,
  resp
});

export const getAttributes = () => dispatch => {
  dispatch(request());
  return api
    .get("/financial_institutions/reports/get_attributes")
    .then(resp => {
      dispatch(listAttirbutesSuccess(resp));
      return Promise.resolve(resp);
    })
    .catch(error => {
      dispatch(listAttirbutesFailure(error));
      return Promise.reject(error);
    });
};

export const REPORT_DETAIL_SUCCESS = 'REPORT_DETAIL_SUCCESS';

const reportDetailSuccess = resp => ({
  type: REPORT_DETAIL_SUCCESS,
  resp
});

export const submitReportDetail = (data) => dispatch => {
  dispatch(request());
  dispatch(reportDetailSuccess(data));
  return Promise.resolve(data);
}

export const REPORT_FILTERS_SUCCESS = 'REPORT_FILTERS_SUCCESS';

const reportFiltersSuccess = resp => ({
  type: REPORT_FILTERS_SUCCESS,
  resp
});

export const submitReportFilters = (data) => dispatch => {
  dispatch(request());
  dispatch(reportFiltersSuccess(data));
  return Promise.resolve(data);
}

export const CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS'
export const CREATE_REPORT_FAILURE = 'CREATE_REPORT_FAILURE'

const createReportSuccess = resp => ({
  type: CREATE_REPORT_SUCCESS,
  resp
});

const createReportFailure = resp => ({
  type: CREATE_REPORT_FAILURE,
  resp
});

export const createReport = (reportObj) => dispatch => {
  dispatch(request());
  return api
    .post("/financial_institutions/reports", reportObj)
    .then(resp => {
      dispatch(createReportSuccess(resp));
      return Promise.resolve(resp);
    })
    .catch((error_detail) => {
      dispatch(createReportFailure(error_detail));
      return Promise.reject(error_detail);
    });
}

export const EDIT_REPORT_SUCCESS = 'EDIT_REPORT_SUCCESS'
export const EDIT_REPORT_FAILURE = 'EDIT_REPORT_FAILURE'

const editReportSuccess = resp => ({
  type: EDIT_REPORT_SUCCESS,
  resp
});

const editReportFailure = resp => ({
  type: EDIT_REPORT_FAILURE,
  resp
});

export const editReport = reportId => dispatch => {
  dispatch(request());
  return api
    .get(`/financial_institutions/reports/${parseInt(reportId)}/edit` )
    .then(resp => {
      dispatch(editReportSuccess(resp));
      return Promise.resolve(resp);
    })
    .catch((error_detail) => {
      dispatch(editReportFailure(error_detail));
      return Promise.reject(error_detail);
    });
}

export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS'
export const UPDATE_REPORT_FAILURE = 'UPDATE_REPORT_FAILURE'

const updateReportSuccess = resp => ({
  type: UPDATE_REPORT_SUCCESS,
  resp
});

const updateReportFailure = resp => ({
  type: UPDATE_REPORT_FAILURE,
  resp
});

export const updateReport = (reportObj, reportId) => dispatch => {
  dispatch(request());
  return api
    .put(`/financial_institutions/reports/${parseInt(reportId)}`, reportObj)
    .then((resp) => {
      dispatch(updateReportSuccess(resp));
      return Promise.resolve(resp);
    })
    .catch((error_detail) => {
      dispatch(updateReportFailure(error_detail));
      return Promise.reject(error_detail);
    });
}

export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS'
export const DELETE_REPORT_FAILURE = 'DELETE_REPORT_FAILURE'

const deleteReportSuccess = resp => ({
  type: DELETE_REPORT_SUCCESS,
  resp
});

const deleteReportFailure = resp => ({
  type: DELETE_REPORT_FAILURE,
  resp
});

export const deleteReport = (reportId) => dispatch => {
  dispatch(request());
  return api
    .delete(`/financial_institutions/reports/${parseInt(reportId)}`)
    .then(resp => {
      dispatch(deleteReportSuccess(resp));
      return Promise.resolve(resp);
    })
    .catch((error_detail) => {
      dispatch(deleteReportFailure(error_detail));
      return Promise.reject(error_detail);
    });
}

export const SHOW_SOLD_REPORT_DEALS_SUCCESS = 'SHOW_SOLD_REPORT_DEALS_SUCCESS'
export const SHOW_SOLD_REPORT_DEALS_FAILURE = 'SHOW_SOLD_REPORT_DEALS_FAILURE'

const showSoldReportDealsSuccess = resp => ({
  type: SHOW_SOLD_REPORT_DEALS_SUCCESS,
  resp
});

const showSoldReportDealsFailure = resp => ({
  type: SHOW_SOLD_REPORT_DEALS_FAILURE,
  resp
});

export const redirectShowReport = report => dispatch => {
  dispatch(showSoldReportDealsSuccess(report));
}

export const showSoldReportDeals = reportId => dispatch => {
  dispatch(request());
  return api
    .get(`/financial_institutions/reports/${parseInt(reportId)}/sold_deals` )
    .then(resp => {
      dispatch(showSoldReportDealsSuccess(resp));
      return Promise.resolve(resp.data);
    })
    .catch((error_detail) => {
      dispatch(showSoldReportDealsFailure(error_detail));
      return Promise.reject(error_detail);
    });
}

export const SHOW_BOUGHT_REPORT_DEALS_SUCCESS = 'SHOW_BOUGHT_REPORT_DEALS_SUCCESS'
export const SHOW_BOUGHT_REPORT_DEALS_FAILURE = 'SHOW_BOUGHT_REPORT_DEALS_FAILURE'

const showBoughtReportDealsSuccess = resp => ({
  type: SHOW_BOUGHT_REPORT_DEALS_SUCCESS,
  resp
});

const showBoughtReportDealsFailure = resp => ({
  type: SHOW_BOUGHT_REPORT_DEALS_FAILURE,
  resp
});

export const showBoughtReportDeals = reportId => dispatch => {
  dispatch(request());
  return api
    .get(`/financial_institutions/reports/${parseInt(reportId)}/bought_deals` )
    .then(resp => {
      dispatch(showBoughtReportDealsSuccess(resp));
      return Promise.resolve(resp.data);
    })
    .catch((error_detail) => {
      dispatch(showBoughtReportDealsFailure(error_detail));
      return Promise.reject(error_detail);
    });
}